// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__cIKWF","modalForm":"UpgradeEpcsModal_modalForm__2pZDV","modalFooter":"UpgradeEpcsModal_modalFooter__3OMHc"};